import ServiceCRUD from '../../../services/ServiceCRUD';
import { apiCase as http, apiInstagramChat } from '../../../http';

class ClientService extends ServiceCRUD {
  constructor() {
    super('cliente');
  }

  getAllFilter(
    entityName,
    page,
    limit,
    filters = {},
    isAccountInContact,
    accountId
  ) {
    const arrayFilters = Object.entries(filters);

    let query = `/entity/${entityName}/select?page=${page}&size=${limit}`;

    arrayFilters.forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          query += `&${key}[]=${val}`;
        });
      } else {
        query += `&${key}=${value}`;
      }
    });

    if (isAccountInContact !== undefined) {
      query += `&isAccountInContact=${isAccountInContact}`;
    }
    if (accountId !== undefined) {
      query += `&accountId=${accountId}`;
    }

    return http.get(query);
  }

  wideSearch(params) {
    params = { ...params, requestLimit: 50 };
    return http.get('/client/wideSearch', { params });
  }

  async getImportFieldsByBroadcastListId(broadcastListId) {
    const result = await apiInstagramChat.get(
      `/broadcastList/${broadcastListId}/import-fields`
    );
    return result.data;
  }
}

export default new ClientService();
